export default "__VITE_ASSET__4d0aa464__"